import React from "react";
import "./Marquee.css";

const Marquee = ({ companyLogos }) => {
  return (
    <div className="marquee-container">
      <div className="marquee-content">
        {/* Original Content */}
        {companyLogos.map((logo, index) => (
          <div key={index} className="marquee-item">
            <img src={logo} alt={`Company ${index + 1}`} />
          </div>
        ))}
        {/* Duplicate Content for Seamless Scroll */}
        {companyLogos.map((logo, index) => (
          <div key={`duplicate-${index}`} className="marquee-item">
            <img src={logo} alt={`Company ${index + 1}`} />
          </div>
        ))}
         {companyLogos.map((logo, index) => (
          <div key={`duplicate2-${index}`} className="marquee-item">
            <img src={logo} alt={`Company ${index + 1}`} />
          </div>
        ))}

      </div>
    </div>
  );
};

export default Marquee;
